import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { CrossSvg } from '../assets';

const FullCrossPlus = ({ top = 0, index }) => {
    const key = index + index - 1;
    return (
        <>
            <Box
                top={top}
                position={'absolute'}
                left={['20px', '40px']}
                right={'0'}
                width={['calc(100% - 40px)', 'calc(100% - 80px)']}
            >
                <Box display={'flex'} justifyContent={'space-between'} width={'calc(100% + 3px)'}>
                    <CrossSvg style={{ marginLeft: '-3px' }} />
                    <CrossSvg />
                </Box>
            </Box>
            <Box
                top={top - 196.5}
                position={'absolute'}
                left={['20px', '40px']}
                right={'0'}
                width={['calc(100% - 40px)', 'calc(100% - 80px)']}
            >
                <Box display={'flex'} justifyContent={'space-between'} width={'calc(100% + 3px)'}>
                    <Text
                        ml={`-${String(key).length * 5}px`}
                        as={'span'}
                        fontSize={'8px'}
                        fontWeight={'light'}
                        color={'brandAlpha.600'}
                    >
                        {key}.0
                    </Text>
                </Box>
            </Box>
        </>
    );
};

export default FullCrossPlus;

// 1 1
// 2 3
// 3 5
// 4 7
// 5 9
